export default __webpack_public_path__ + "static/media/No tax worldwide.ad351427.svg";